import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=bbf11f28"
var script = {}
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=bbf11f28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports